<template lang="html">
  <div class="sidebar-nav" :class="sidebarIsOpen">
    <v-layout align-center class="aside-brand">
      <v-flex class="toggle-sidebar-btn">
        <v-btn
          class="ma-0"
          icon
          solo
          color
          :ripple="false"
          small
          @click="toggleSidebar"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               class="stroke-current">
            <circle cx="12" cy="12" r="10"></circle>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
        </v-btn>
      </v-flex>
    </v-layout>
    <app-nav></app-nav>
  </div>
</template>

<script>
import Nav from './navs'

export default {
  components: {
    'app-nav': Nav
  },
  data: () => ({}),
  methods: {
    toggleSidebar () {
      this.$store.dispatch('sidebar/toggleSidebar')
    }
  },
  computed: {
    sidebarIsOpen () {
      return {
        'open': this.$store.state.sidebar.sidebarOpen
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar/Sidebar.vue